import {
  HiUserPlus,
  HiUserCircle,
  HiPlay,
  HiClock,
  HiCheckCircle,
  HiCheckBadge,
  HiArrowUturnLeft,
  HiXCircle,
  HiTrash,
  HiNoSymbol,
  HiXMark,
  HiDocumentText,
  HiFlag,
  HiExclamationTriangle,
  HiExclamationCircle,
  HiPause,
} from 'react-icons/hi2'
import type { ComponentType } from 'react'

export const ICON_MAP: Record<string, ComponentType<{ className?: string }>> = {
  HiUserPlus,
  HiUserCircle,
  HiPlay,
  HiClock,
  HiCheckCircle,
  HiCheckBadge,
  HiArrowUturnLeft,
  HiXCircle,
  HiTrash,
  HiNoSymbol, // Usado para CANCELADA (substitui HiBan)
  HiXMark,
  HiDocumentText,
  HiFlag,
  HiExclamationTriangle,
  HiExclamationCircle,
  HiPause,
}
